import Konva from 'konva';
import GraphicBase from './base';

class GraphicArea extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = false;
  }

  build() {
    const { stage } = this;
    const points = [];

    this.data.forEach((pid) => {
      points.push(stage.pointDict[pid].x, stage.pointDict[pid].y);
    });

    this.ele = new Konva.Line({
      id: this.id,
      points,
      fill: 'rgba(255, 0, 0, 0.5)',
      stroke: 'blue',
      strokeWidth: 1,
      closed: true,
    });

    this.ele.on('dragmove', (e) => {
      stage.blockDragHandler(e);
    });

    this.ele.on('click', (e) => {
      stage.blockClickHandler(e);
    });

    stage.areaLayer.add(this.ele);
    this.layer = stage.areaLayer;

    return this.ele;
  }
}

export default GraphicArea;
